var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feature-list-plain"},[_c('ul',{staticClass:"feature-list-plain__list"},_vm._l((_vm.features),function(feature){return _c('li',{key:feature.id},[_c('AppFeatureListItem',{attrs:{"text":feature.longText,"icon":feature.icon,"plain":""}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }